import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableEnginCreatePage = withAsyncLoading(async () =>
    import('./EnginCreatePage').then((res) => res.EnginCreatePage)
);

export { LoadableEnginCreatePage };
